<template>
  <div id="recuperar">
    <vue-headful :title="$store.state.option['recuperar_title-' + lang]" :lang="lang" />
    <titulo></titulo>
    <div class="container">
      <div class="text-jsutify mt-5" v-if="ok" v-html="$store.state.option['recuperarSuc-' + lang]"></div>
      <div class="card card-login mx-auto mt-5" v-else>
        <div class="card-body">
            <div class="form-group">
              <div class="form-label-group">
                <input type="email" id="inputEmail" class="form-control" :placeholder="$store.state.option['email233-' + lang]" required="required" autofocus="autofocus" v-model="form.email" @keydown.enter.prevent="submit" />
                <label for="inputEmail">{{$store.state.option['email233-' + lang]}}</label>
              </div>
            </div>
            <a class="btn btn-primary btn-block btn-lg mao text-uppercase" @click="submit()" href="javascript:void(0)">{{$store.state.option['recuperarbot-' + lang]}}</a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import titulo from '@/components/titulo'
import { mapMutations } from 'vuex'

export default {
  components: { titulo },
  data () {
    return {
      form: {
        email: ''
      },
      ok: 0,
      login: '',
      lang: ''
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_TITULO',
      'SET_SUBTITULO',
      'SET_AVISO'
    ]),
    init () {
      if (this.$store.state.option1) {
        this.lang = this.$store.state.lang
        this.SET_TITULO(this.$store.state.option['recuperar_title-' + this.lang])
        this.SET_SUBTITULO(this.$store.state.option['recuperar_subtitle-' + this.lang])
        this.SET_LOAD()
        this.ok = 0
      } else {
        this._.delay(this.init, 100)
      }
    },
    submit () {
      this.SET_LOAD(true)
      this.ok = 0
      this.axios.post('/drivers/password-reset', this.form).then((res) => {
        this.ok = 1
        this.SET_LOAD()
      }, (er) => {
        this.axios.post('/backoffice/password/email', this.form).then((res) => {
          this.ok = 1
          this.SET_LOAD()
        }, (er) => {
          this.SET_AVISO(er.response.data.errors.email[0])
        })
      })
    }
  }
}
</script>
